export default "__VITE_ASSET__CVvL9v7F__"